import { createFileRoute } from "@tanstack/react-router";
import LawnMowerBrowse from "@/pages/LawnMowerBrowse";
import { lawnMowerBrowseQueryOptions, lawnMowerAffiliateBrowseQueryOptions } from "@/lib/lawnMowerBrowseQuery";

export const Route = createFileRoute("/lawn-mowers/brand/$filterValue")({
  loader: async ({ context }) => {
    await Promise.all([
      context.queryClient.ensureQueryData(lawnMowerBrowseQueryOptions),
      context.queryClient.ensureQueryData(lawnMowerAffiliateBrowseQueryOptions),
    ]);
  },
  component: LawnMowerBrowse,
});
